import React from 'react';
import { translate } from 'react-i18next';
import './header.css';
import './en.css';
import Menu_btn from '../../image/header/Menu_btn.png';
import Down_Arrow from '../../image/header/down_arrow.png';
// import Conf_1 from '../../image/header/conf_1_university.png';
// import Conf_2 from '../../image/header/conf_2_engineer.png';
// import Conf_3 from '../../image/header/conf_2_y_innovators.png';
// import Conf_4 from '../../image/header/conf_4_it_prof.png';
// import Conf_5 from '../../image/header/conf_5_anyone.png';
// import redDot from '../../image/header/red_dot.png';
import { Link } from "react-router-dom";

class Header extends React.Component {

    state = {
        isTop: true,
        Hover: false,
        LabHover: false,
        ConfHover: false,
        CompHover: false,
        LabHoverMobile: false,
        ConfHoverMobile: false,
        CompHoverMobile: false,
        forMac: false,
    };
    componentDidMount() {
        // var path = window.location.pathname
        // path = path.slice(1, 3);

        document.addEventListener('scroll', () => {
            const isTop = window.scrollY < 100;
            if (isTop !== this.state.isTop) {
                this.setState({ isTop })
            }
        });
        var header = document.getElementById('header');
        document.body.addEventListener("click", function () {
            document.getElementById('navbarSupportedContent').classList.remove("show");
        }, false);
        header.addEventListener("click", function (ev) {

            ev.stopPropagation(); //this is important! If removed, you'll get both alerts
        }, false);
    };
    onMouseEnter(type) {
        if (type === 'Lab') {
            this.setState({ LabHover: true });
            this.setState({ ConfHover: false });
            this.setState({ CompHover: false });
        } else if (type === 'Conf') {
            this.setState({ ConfHover: true });
            this.setState({ CompHover: false });
            this.setState({ LabHover: false });
        } else {
            this.setState({ CompHover: true });
            this.setState({ ConfHover: false });
            this.setState({ LabHover: false });
        }
        this.setState({ Hover: true });

    }

    onMouseLeave() {
        this.setState({ LabHover: false });
        this.setState({ ConfHover: false });
        this.setState({ CompHover: false });
        this.setState({ Hover: false });
    }
    EnterLab() {
        this.setState({ LabHoverMobile: true });
        this.setState({ ConfHoverMobile: false });
        this.setState({ CompHoverMobile: false });
    }
    LeaveLab() {
        this.setState({ LabHoverMobile: false });
    }
    EnterConf() {
        this.setState({ ConfHoverMobile: true });
        this.setState({ CompHoverMobile: false });
        this.setState({ LabHoverMobile: false });
    }
    LeaveConf() {
        this.setState({ ConfHoverMobile: false });
    }
    EnterComp() {
        this.setState({ CompHoverMobile: true });
        this.setState({ ConfHoverMobile: false });
        this.setState({ LabHoverMobile: false });
    }
    LeaveComp() {
        this.setState({ CompHoverMobile: false });
    }
    ToggleConf() {
        const currentState = this.state.ConfHoverMobile;
        this.setState({ ConfHoverMobile: !currentState });
    }
    ToggleComp() {
        const currentState = this.state.CompHoverMobile;
        this.setState({ CompHoverMobile: !currentState });
    }
    ToggleLab() {
        const currentState = this.state.LabHoverMobile;
        this.setState({ LabHoverMobile: !currentState });
    }
    confJump() {
        this.onMouseLeave();
    }

    compJump() {
        this.onMouseLeave();
    }
    LabJump() {
        this.onMouseLeave();
    }
    confJumpMobile() {
        this.inputElement.click();
        console.log(this.inputElement);
        alert("1");
        this.ToggleConf();
    }
    compJumpMobile() {
        this.ToggleComp();
        this.inputElement.click();
    }
    LabJumpMobile() {
        this.ToggleLab();
        this.inputElement.click();
    }
    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
    }
    componentWillMount() {

        var isIOS = (function () {
            var iosQuirkPresent = function () {
                var audio = new Audio();

                audio.volume = 0.5;
                return audio.volume === 1;   // volume cannot be changed from "1" on iOS 12 and below
            };

            var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            var isAppleDevice = navigator.userAgent.includes('Macintosh');
            var isTouchScreen = navigator.maxTouchPoints >= 1;   // true for iOS 13 (and hopefully beyond)

            return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
        })();

        if (isIOS) {
            require("./forMac.css");
        }
    };

    render() {
        const en_to = this.props.en_to;
        const en_onClick = this.props.en_onClick;
        const tc_to = this.props.tc_to;
        const tc_onClick = this.props.tc_onClick;
        const sc_to = this.props.sc_to;
        const sc_onClick = this.props.sc_onClick;
        const { t } = this.props;
        // const { en } = this.state;
        const match = this.props.match;
        return (
            <header id="header" className={this.state.isTop ? this.state.Hover ? 'header_lightbg fixed-top py-1 d-flex justify-content-center' : 'header_darkbg fixed-top py-1 d-flex justify-content-center' : 'header_lightbg fixed-top py-1 d-flex justify-content-center'} onMouseLeave={() => this.onMouseLeave()}>

                {/* <div className={match === "/tc" ? "tc containerDIV-award d-block d-sm-flex" : match === "/sc" ? "sc containerDIV-award d-block d-sm-flex" : "containerDIV-award d-block d-sm-flex"}>
                    <a href={t('live-zoom-link')} target="_blank" className="no_border m-2">
                        <div className='live-btn-1'></div>
                    </a>
                    <a href={t('live-vzan-link')} target="_blank" className="no_border m-2">
                        <div className='live-btn-2'></div>
                    </a>
                </div> */}

                <div className={match === "/tc" ? "tc" : match === "/sc" ? "sc" : ""}>
                    <nav id="nav" className="navbar navbar-expand-xl" >
                        <div className="navbar-inner">
                            <div className="d-flex">
                                <div>
                                    <Link className="navbar-brand" to={match + "/home/"} onClick={() => this.goToTop()}><img src={t('header-logo')} className="img-fluid div-nav-logo" alt="" /></Link>
                                </div>
                            </div>
                            <div className="d-flex toggler-gp">
                                <div className="d-none d-lg-flex d-xl-none btn-gp-Jn-2">
                                    {/* <Link to={match + "/conference/#programme"} onClick={() => this.confJump()} className="no_border"><button className={t('btn_JnConf TXT_medium')}>{t('Join the Online Conference 2')}</button></Link> */}
                                    {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_JnComp TXT_medium">{t('Join the Competition 2')}</button></a> */}
                                    {/* <a href={t('live-zoom-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_Live TXT_medium">{t('Watch the LIVE Awards Ceremony')}</button></a> */}
                                </div>
                                <button ref={input => this.inputElement = input} className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span><img src={Menu_btn} className="menu-icon" alt="" /></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse collapse-menu" id="navbarSupportedContent_1">
                                <div className="col-swap">
                                    <div className="d-flex justify-content-end collapse-menu">
                                        <div className="d-flex top-menu">
                                            <div className="d-none d-lg-flex btn-gp-Jn">
                                                {/* <Link to={match + "/conference/#programme"}  onClick={() =>this.confJump()} className="no_border"><button className={t('btn_JnConf TXT_medium')}>{t('Join the Online Conference 2')}</button></Link> */}
                                                {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-highlight01 w-100 px-4">{t('Join the Competition')}</button></a> */}
                                                {/* <Link to={match + "/competition/"} onClick={() => this.goToTop()} aria-current="page" className="no_border"><button className="btn btn-highlight01 w-100 px-4">{t('Join the Competition')}</button></Link> */}
                                                {/* <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-highlight01 w-100 btn-auto">{t('REGISTER FOR CONFERENCE AWARD CEREMONY 1')}{t('REGISTER FOR CONFERENCE AWARD CEREMONY 2')}</button></a> */}
                                                {/* <a href={t('live-zoom-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('live-zoom-text-1')}<br className='d-sm-none' /> {t('live-zoom-text-2')}</button></a>
                                                <a href={t('live-vzan-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('live-vzan-text-1')}<br className='d-sm-none' /> {t('live-vzan-text-2')}</button></a> */}
                                                <a href={t('booklet-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('booklet-text')}</button></a>
                                                {/* <a href={t('award-live-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_Live TXT_medium">{t('Watch the LIVE Awards Ceremony')}</button></a> */}
                                            </div>
                                            <div className="d-flex lang-gp-1 align-items-center">
                                                <Link to={en_to} onClick={en_onClick} className="mx-3">{t('EN')}</Link>
                                                <Link to={tc_to} onClick={tc_onClick} className="mx-3 TC">{t('TC')}</Link>
                                                <Link to={sc_to} onClick={sc_onClick} className="mx-3 SC">{t('SC')}</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex collapse-menu">
                                        <ul className="navbar-nav collapse-menu-ms-auto">
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <Link className="nav-link" aria-current="page" to={match + "/about/"} onClick={() => this.goToTop()}>{t('About')}</Link>
                                            </li>
                                            <li className="nav-item dropdown-menu-btn-comp-xl" onMouseEnter={() => this.onMouseEnter("Comp")}>
                                                <Link className="nav-link" aria-current="page" to={match + "/competition/"}>{t('Competition')}
                                                    {/* <img src={Down_Arrow} className="ms-1 arrow-img" alt=""></img> */}
                                                </Link>
                                            </li>
                                            <li className="nav-item dropdown-menu-btn-conf-xl" onMouseEnter={() => this.onMouseEnter("Conf")}>
                                                <Link className="nav-link " aria-current="page" to={match + "/conference/"}>{t('Conference')}
                                                    {/* <img src={Down_Arrow} className="ms-1 arrow-img" alt=""></img> */}
                                                </Link>
                                            </li>
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <Link className="nav-link" aria-current="page" to={match + "/awardsceremony/"} onClick={() => this.goToTop()}>{t('Awards Ceremony')}</Link>
                                            </li>
                                            {/* <li className="nav-item dropdown-menu-btn-comp-xl" onMouseEnter={() => this.onMouseEnter("Lab")}>
                                                <Link className="nav-link" aria-current="page" to={match + "/E&MAILab/about"}>{t('E&M AI Lab')}<img src={Down_Arrow} className="ms-1 arrow-img" alt=""></img></Link>
                                            </li> */}
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <Link className="nav-link" aria-current="page" to={match + "/acknowledgements/"} onClick={() => this.goToTop()}>{t('Acknowledgements')}</Link>
                                            </li>
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <Link className="nav-link" aria-current="page" to={match + "/sponsors/"} onClick={() => this.goToTop()}>{t('Sponsors')}</Link>
                                            </li>
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <Link className="nav-link" aria-current="page" to={match + "/gallery/"} onClick={() => this.goToTop()}>{t('Gallery')}</Link>
                                            </li>
                                            <li className="nav-item" onMouseEnter={() => this.onMouseLeave()}>
                                                <a href={t('2021-url')} target="_blank" rel="noopener noreferrer" className="nav-link">{t('Past Events')}</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </nav>
                    <div className="collapse navbar-collapse collapse-menu" id="navbarSupportedContent">
                        <div className="container-fluid col-swap">
                            <div className="d-flex mb-3">
                                {/* <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-highlight01 w-100 btn-auto">{t('REGISTER FOR CONFERENCE AWARD CEREMONY 1')}<br className='d-sm-none' />{t('REGISTER FOR CONFERENCE AWARD CEREMONY 2')}</button></a> */}
                                {/* <a href={t('live-zoom-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('live-zoom-text-1')}<br className='d-sm-none' /> {t('live-zoom-text-2')}</button></a>
                                <a href={t('live-vzan-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('live-vzan-text-1')}<br className='d-sm-none' /> {t('live-vzan-text-2')}</button></a> */}
                                <a href={t('booklet-link')} target="_blank" className="no_border mx-2"><button className="btn btn-highlight01 w-100 btn-auto">{t('booklet-text')}</button></a>
                            </div>
                            <div className="d-flex justify-content-between collapse-menu">
                                <div className="d-flex top-menu">
                                    <div className="d-flex lang-gp">
                                        <Link to={en_to} onClick={en_onClick} className="me-4">{t('EN')}</Link>
                                        <Link to={tc_to} onClick={tc_onClick} className="me-4 TC">{t('TC')}</Link>
                                        <Link to={sc_to} onClick={sc_onClick} className="me-4 SC">{t('SC')}</Link>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-highlight01 w-100">{t('Join the Competition')}</button></a> */}
                                    {/* <Link to={match + "/competition/"} onClick={() => this.goToTop()} aria-current="page" className="no_border"><button className="btn btn-highlight01 w-100">{t('Join the Competition')}</button></Link> */}

                                </div>
                            </div>
                            <div className="d-flex collapse-menu">
                                <ul className="navbar-nav collapse-menu-ms-auto">
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to={match + "/about"} onClick={() => this.goToTop()}>{t('About')}</Link>
                                    </li>
                                    <li className="nav-item dropdown-menu-btn-comp" onMouseEnter={() => this.EnterComp()}>
                                        <div className="nav-link" onClick={() => this.ToggleComp()}>{t('Competition')}<img src={Down_Arrow} className={this.state.CompHoverMobile ? 'ms-1 arrow-img-2 float-end hovered' : 'ms-1 arrow-img-2 float-end'} alt=""></img></div>
                                        <ul className={this.state.CompHoverMobile ? 'dropdown-menu dropdown-menu-item-comp hovered' : 'dropdown-menu dropdown-menu-item-comp'} aria-labelledby="dropdownMenuLink">
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/"} onClick={() => this.compJumpMobile()}>{t('comp-sub-theme-1')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition2/"} onClick={() => this.compJumpMobile()}>{t('comp-sub-theme-2')}</Link></li>
                                            {/* <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Evaluation"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-3')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Prizes"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-4')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Results"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-9')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Timeline"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-5')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Acknowledgements"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-6')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Data"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-7')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/competition/#Rules"} onClick={() => this.compJumpMobile()}>{t('comp-sub-menu-item-8')}</Link></li> */}
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown-menu-btn-conf" onMouseEnter={() => this.EnterConf()} >
                                        <div className="nav-link" onClick={() => this.ToggleConf()}>{t('Conference')}<img src={Down_Arrow} className={this.state.ConfHoverMobile ? 'ms-1 arrow-img-2 float-end hovered' : 'ms-1 arrow-img-2 float-end'} alt=""></img></div>
                                        <ul className={this.state.ConfHoverMobile ? 'dropdown-menu dropdown-menu-item-conf hovered' : 'dropdown-menu dropdown-menu-item-conf'} aria-labelledby="dropdownMenuLink">
                                            <li><Link className="dropdown-item" to={match + "/conference/#theme"} onClick={() => this.confJumpMobile()}>{t('Theme')}</Link></li>
                                            <li><Link className="dropdown-item" to={match + "/conference/#programme"} onClick={() => this.confJumpMobile()}>{t('Programme')}</Link></li>
                                            <li><Link className="dropdown-item" to={match + "/conference/#speakers"} onClick={() => this.confJumpMobile()}>{t('Speakers')}</Link></li>
                                            <li><Link className="dropdown-item" to={match + "/conference/#audience"} onClick={() => this.confJumpMobile()}>{t('Target Audience')}</Link></li>
                                            <li><Link className="dropdown-item" to={match + "/conference/#why"} onClick={() => this.confJumpMobile()}>{t('Why You Should Join')}</Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to={match + "/awardsceremony/"} onClick={() => this.goToTop()}>{t('Awards Ceremony')}</Link>
                                    </li>
                                    {/* <li className="nav-item dropdown-menu-btn-comp" onMouseEnter={() => this.EnterLab()}>
                                        <div className="nav-link" onClick={() => this.ToggleLab()}>{t('E&M AI Lab')}<img src={Down_Arrow} className={this.state.LabHoverMobile ? 'ms-1 arrow-img-2 float-end hovered' : 'ms-1 arrow-img-2 float-end'} alt=""></img></div>
                                        <ul className={this.state.LabHoverMobile ? 'dropdown-menu dropdown-menu-item-lab hovered' : 'dropdown-menu dropdown-menu-item-lab'} aria-labelledby="dropdownMenuLink">
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/E&MAILab/about"} onClick={() => this.LabJumpMobile()}>{t('lab-sub-menu-item-1')}</Link></li>
                                            <li><Link className="dropdown-item dropdown-comp-item-2" to={match + "/E&MAILab/event"} onClick={() => this.LabJumpMobile()}>{t('lab-sub-menu-item-2')}</Link></li>
                                        </ul>
                                    </li> */}
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to={match + "/acknowledgements/"} onClick={() => this.goToTop()}>{t('Acknowledgements')}</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to={match + "/sponsors/"} onClick={() => this.goToTop()}>{t('Sponsors')}</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to={match + "/gallery/"} onClick={() => this.goToTop()}>{t('Gallery')}</Link>
                                    </li>
                                    <li className="nav-item">
                                        <a href={t('2021-url')} target="_blank" rel="noopener noreferrer" className="nav-link">{t('Past Events')}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={this.state.LabHover ? 'dropdown-lab hover' : 'dropdown-lab'} onMouseEnter={() => this.onMouseEnter("Lab")}>
                        <div className="container-fluid">
                            <div className="d-flex">
                                <div className="dropdown-conf-comp-menu">
                                    <div className={t('dropdown-conf-comp-headline TXT_bold')}>{t('E&M AI Lab')}</div>
                                    <ul className="dropdown-conf-comp-list">
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/E&MAILab/about"} onClick={() => this.LabJump()}>{t('lab-sub-menu-item-1')}</Link></li>
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/E&MAILab/event"} onClick={() => this.LabJump()}>{t('lab-sub-menu-item-2')}</Link></li>
                                    </ul>
                                </div>
                                <div className="dropdown-conf-comp-info">
                                    <div className={t('dropdown-comp-info-headline TXT_bold')}>{t('Highlights')}</div>
                                    <div className="dropdown-comp-info-1st-row d-flex">
                                        <div className="dropdown-lab-info-item-1">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className={this.state.ConfHover ? 'dropdown-conf hover' : 'dropdown-conf'} onMouseEnter={() => this.onMouseEnter("Conf")}>
                        <div className="container-fluid">
                            <div className="d-flex">
                                <div className="dropdown-conf-comp-menu">
                                    <div className={t('dropdown-conf-comp-headline TXT_bold')}>{t('Conference')}</div>
                                    <ul className="dropdown-conf-comp-list">
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/conference/#theme"} onClick={() => this.confJump()}>{t('Theme')}</Link></li>
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/conference/#programme"} onClick={() => this.confJump()}>{t('Programme')}</Link></li>
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/conference/#speakers"} onClick={() => this.confJump()}>{t('Speakers')}</Link></li>
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/conference/#audience"} onClick={() => this.confJump()}>{t('Target Audience')}</Link></li>
                                        <li><Link className="dropdown-item dropdown-conf-comp-item" to={match + "/conference/#why"} onClick={() => this.confJump()}>{t('Why You Should Join')}</Link></li>
                                    </ul>
                                </div>
                                <div className="dropdown-conf-comp-info">
                                    <div className={t('dropdown-conf-info-headline TXT_bold')}>{t('Target Audience')}</div>
                                    <div className="dropdown-conf-info-1st-row d-flex">
                                        <div className="dropdown-conf-info-item">
                                            <div className="dropdown-conf-info-item-img d-flex justify-content-center"><img src={Conf_1} className="img-fluid" alt="" /></div>
                                            <div className="dropdown-conf-info-item-text text-center">{t('conf-target-info-title-1')}</div>
                                        </div>
                                        <div className="dropdown-conf-info-item">
                                            <div className="dropdown-conf-info-item-img d-flex justify-content-center"><img src={Conf_2} className="img-fluid" alt="" /></div>
                                            <div className="dropdown-conf-info-item-text text-center">{t('conf-target-info-title-2')}</div>
                                        </div>
                                        <div className="dropdown-conf-info-item">
                                            <div className="dropdown-conf-info-item-img d-flex justify-content-center"><img src={Conf_3} className="img-fluid" alt="" /></div>
                                            <div className="dropdown-conf-info-item-text text-center">{t('conf-target-info-title-3')}</div>
                                        </div>
                                        <div className="dropdown-conf-info-item">
                                            <div className="dropdown-conf-info-item-img d-flex justify-content-center"><img src={Conf_4} className="img-fluid" alt="" /></div>
                                            <div className="dropdown-conf-info-item-text text-center">{t('conf-target-info-title-4')}</div>
                                        </div>
                                    </div>
                                    <div className="dropdown-conf-info-2nd-row">
                                        <div className="dropdown-conf-info-item-xl d-flex">
                                            <div className="dropdown-conf-info-item-img d-flex justify-content-center"><img src={Conf_5} className="img-fluid" alt="" /></div>
                                            <div className="dropdown-conf-info-item-text d-flex align-items-center">{t('conf-target-info-title-5')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className={this.state.CompHover ? 'dropdown-comp hover' : 'dropdown-comp'} onMouseEnter={() => this.onMouseEnter("Comp")}>
                        <div className="container-fluid">
                            <div className='dropdown-comp-border'>
                                <h5 className='text-center pt-3'>{t('Competition')}</h5>
                                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center align-items-md-stretch pb-5">
                                    <Link className="card header-comp-card-1 p-1 m-4 m-md-2 h-max no_border" aria-current="page" to={match + "/competition/"}>
                                        <div className="comp-card-item-1 text-center d-flex justify-content-center align-items-center px-5 w-100"><div><div className="comp-card-text-1">Build Your</div><div className="comp-card-text-2">AI Model</div></div></div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text header-card-text text-center"><strong>Develop a generalised AI model for predicting cooling demand across multiple buildings</strong></p>
                                        </div>
                                    </Link>
                                    <Link className="card comp-card-2 p-1 m-4 m-md-2 no_border" aria-current="page" to={match + "/competition2/"}>
                                        <div className="comp-card-item-2 text-center d-flex justify-content-center align-items-center px-5 w-100"><div><div className="comp-card-text-1">Pitch Your</div><div className="comp-card-text-3">Innovative Proposal</div></div></div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text text-center"><strong>Pitch your innovative proposal for the Best AI Innovations in Construction and Engineering 2025 (BAICE 2025)</strong></p>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

            </header>

        );
    }
}

export default translate("translations")(Header);



// WEBPACK FOOTER //
// ./src/components/layout/header.js